import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Card, Dropdown, Nav, Tab } from "react-bootstrap";
//
import PageHeader from "../../../components/general/PageHeader";
import Referral from "./Referral";
import Security from "./Security";
import Billing from "./Billing";
import Profile from "./Profile";
import MyIndicators from "./MyIndicators";

function Account({ windowSize }) {
  const paymentFeature = process.env.REACT_APP_PEYMENT_FEATURE;
  const [activeTab, setActiveTab] = useState({
    name: "Billing and Payments",
    value: "billing",
  });

  const [tabsList, setTabsList] = useState([
    {
      name: "Billing and Payments",
      value: "billing",
    },
    {
      name: "Personal Information",
      value: "personal",
    },
    {
      name: "Security",
      value: "security",
    },
    {
      name: "Referral Program",
      value: "referral",
    },
  ]);

  const changeActiveTab = (item) => {
    let tab = { ...activeTab };
    tab.name = item.name;
    tab.value = item.value;
    setActiveTab(tab);
  };

  const changeTabsList = () => {
    console.log("13");
    let tabs = [...tabsList];

    if (paymentFeature === "false") {
      tabs = tabs.filter((item) => item.value !== "billing");
    }

    setTabsList(tabs);

    changeActiveTab(tabs[0]);
  };

  useEffect(() => {
    changeTabsList();
    // eslint-disable-next-line
  }, []);

  return (
    <div id="account">
      <PageHeader title="Account" />

      <Tab.Container activeKey={activeTab.value}>
        {windowSize > 768 && (
          <div className="tab-header">
            <Nav className="align-items-end">
              {tabsList.map((item, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    eventKey={item.value}
                    onClick={() => changeActiveTab(item)}
                  >
                    {item.name}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
        )}

        <Card>
          {windowSize <= 768 && (
            <Card.Header className="with-dropdown tab-dropdown-header">
              <Dropdown id="tab-dropdown">
                <Dropdown.Toggle>{activeTab.name}</Dropdown.Toggle>
                <Dropdown.Menu className="fit">
                  <Nav>
                    {tabsList.map((item, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link
                          eventKey={item.value}
                          onClick={() => changeActiveTab(item)}
                        >
                          {item.name}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Dropdown.Menu>
              </Dropdown>
            </Card.Header>
          )}

          <Card.Body>
            <Tab.Content>
              <Tab.Pane eventKey="personal" mountOnEnter unmountOnExit>
                <Profile />
              </Tab.Pane>
              <Tab.Pane eventKey="billing" mountOnEnter unmountOnExit>
                <Billing />
              </Tab.Pane>
              <Tab.Pane eventKey="security" mountOnEnter unmountOnExit>
                <Security />
              </Tab.Pane>
              <Tab.Pane eventKey="referral" mountOnEnter unmountOnExit>
                <Referral />
              </Tab.Pane>
              <Tab.Pane eventKey="indicators" mountOnEnter unmountOnExit>
                <MyIndicators />
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Card>
      </Tab.Container>
    </div>
  );
}

Account.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(Account);
